export const ensureStringArray = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value
      .filter((item): item is string => typeof item === "string")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return [];

    // Handle JSON-encoded arrays (legacy/migration cases)
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return ensureStringArray(parsed);
      }
    } catch {
      // Fall through to split-based parsing
    }

    return trimmed
      .split(/[;,]/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return [];
};

export const ensureNullableString = (value: unknown): string | null => {
  return typeof value === "string" ? value : null;
};
